const transfromDna  = function (block) {

    const dna = block.dna.split('_')[1];
    const dnaStats = {
        top: dna.substr(0, 2),
        right: dna.substr(2, 2), 
        bottom: dna.substr(4, 2), 
        left: dna.substr(6, 2) 
    };

    return dnaStats;

};

const battle = function (type, blockBase, blockOuter) {

    if (!blockOuter) return false;

    const baseDna = transfromDna(blockBase.blockHead);
    const outerDna = transfromDna(blockOuter.blockHead);

    let result = null;

    if (type == 'top') {
        
        result = parseInt(baseDna.top) - parseInt(outerDna.bottom);

    } else if (type == 'right') {

        result = parseInt(baseDna.right) - parseInt(outerDna.left);

    } else if (type == 'bottom') {

        result = parseInt(baseDna.bottom) - parseInt(outerDna.top); 

    } else if (type == 'left') {

        result = parseInt(baseDna.left) - parseInt(outerDna.right); 

    }

    return { type, result };

};

const getWinner = function (_warResults) {

    const getMax = object => {
        return Object.keys(_warResults).filter(x => {
             return _warResults[x] == Math.max.apply(null, 
             Object.values(_warResults));
       });
    };

    let obj = _warResults;
    let keys = Object.keys(obj), largest = Math.max.apply(null, keys.map(x => obj[x])) 
    let result = keys.reduce((result, key) => { if (obj[key] === largest){ result.push(key); } return result; }, []);

};

const warLogic = function (war) {

    const blocks = war.blocks;

    let results = {};
    let outerBlocks = {};
    let blockDominance = {};

    // console.log(blocks);
    for (let block in blocks) {
        block = parseInt(block);

        let blockBase = blocks[block];
        outerBlocks.top = blocks[block-4];
        outerBlocks.right = blocks[block+1];
        outerBlocks.bottom = blocks[block+4];
        outerBlocks.left = blocks[block-1];

        // Left edge boundry control
        if (block == 5 || block == 9 || block == 13) {
            outerBlocks.left = null;
        }

        // Right edge boundry control
        if (block == 4 || block == 8 || block == 12) {
            outerBlocks.right = null;
        }

        // Individual battles
        let topBattle = battle('top', blockBase, outerBlocks.top);
        let rightBattle = battle('right', blockBase, outerBlocks.right);
        let bottomBattle = battle('bottom', blockBase, outerBlocks.bottom);
        let leftBattle = battle('left', blockBase, outerBlocks.left);
        
        let resultArray = [ topBattle, rightBattle, bottomBattle, leftBattle ].sort((a, b) => {

            let resultA = a.result ? a.result : 1000;
            let resultB = b.result ? b.result : 1000;

            if (resultA > resultB) return 1;
            if (resultA < resultB) return -1;

            return 0;

        });

        let defeated = resultArray[0].result < 0 ? true : false;
        let defeatedPosition = resultArray[0].result < 0 ? resultArray[0].type : null;
        let defeatedBy = resultArray[0].result < 0 ? outerBlocks[resultArray[0].type] : null;

        results[block] = {
            position: block,
            results: resultArray,
            defeated: defeated,
            defeatedBy: defeatedBy,
            defeatedPosition: defeatedPosition
        }

        if (defeatedBy) {
            let defeatedBlock = blockDominance[defeatedBy.owner];
            blockDominance[defeatedBy.owner] = defeatedBlock ? defeatedBlock+1 : 1;    
        } else {
            let safeBlock = blockDominance[blockBase.owner];
            blockDominance[blockBase.owner] = safeBlock ? safeBlock+1 : 1;   
        }
    }

    // getWinner(blockDominance);
    return { results, blockDominance };

};

export { warLogic };


// WEBPACK FOOTER //
// ./src/util/warLogic.js